import { IPoint, Mesh, MeshMaterial, Renderer, Texture, WRAP_MODES } from 'pixi.js';

import { SplineGeometry, SplineGeometrySettings } from './SplineGeometry';

export class SplineDisplay extends Mesh
{
    public autoUpdate: boolean;

    constructor(points: IPoint[], texture: Texture, settings: Partial<SplineGeometrySettings> = {})
    {
        const ropeGeometry = new SplineGeometry(points, {
            thickness: settings.thickness ? settings.thickness : texture.height,
            ...settings,
        });
        const meshMaterial = new MeshMaterial(texture);

        if (ropeGeometry.settings.textureScale > 0)
        {
            texture.baseTexture.wrapMode = WRAP_MODES.REPEAT;
        }
        super(ropeGeometry, meshMaterial);

        this.autoUpdate = ropeGeometry.settings.thickness === 0;
    }

    public get points(): IPoint[]
    {
        return (this.geometry as SplineGeometry).points;
    }

    _render(renderer: Renderer): void
    {
        const geometry: SplineGeometry = this.geometry as any;

        if (this.autoUpdate && geometry.settings.thickness !== this.shader.texture.height)
        {
            geometry.settings.thickness = this.shader.texture.height;
            geometry.update();
        }

        super._render(renderer);
    }
}
